export const gameUtil = function () {

};

gameUtil.prototype.gridPositions = function (ans) {
    let positions = [];
    for (let i = 0; i < ans.length; i++) {
        // 0 = up, 1 = up-right, 2 = right, 3 = down-right, 4 = down
        // 5 = down-left, 6 = left, 7 = up-left
        let posX = ans.x,
            posY = ans.y;
        if (ans.direction == 1) {
            posX += i;
            posY -= i;
        } else if (ans.direction == 2) {
            posX += i;
        } else if (ans.direction == 3) {
            posX += i;
            posY += i;
        } else if (ans.direction == 4) {
            posY += i;
        } else if (ans.direction == 5) {
            posX -= i;
            posY += i;
        } else if (ans.direction == 6) {
            posX -= i;
        } else if (ans.direction == 7) {
            posX -= i;
            posY -= i;
        } else {
            // up
            posY -= i;
        }

        positions.push({
            x: posX,
            y: posY,
        });
    }

    return positions;
};

const myPlugin = {
    install: function (Vue, options) {
        Vue.prototype.$gameUtil = new gameUtil()
    }
}

export default myPlugin;